import Rows from "../jslibs/Rows"

export type TUnit = "µg"|"g"|"mg"|"kg"|"cup"|"tbsp"|"tsp"
export const TUnits = ["kg","g","mg","µg","cup","tbsp","tsp"]

export interface IFoodAmount {
    id:number
    amount:number
    unit:TUnit
}
export interface IRecipe {
    _id:string
    name:string
    description:string
    servings:number
    user:string
    created:number
    updated:number
    foods:IFoodAmount[]
}
export default class Recipes extends Rows<string, IRecipe> {
    private _userId:string
    constructor(userId:string, rows:IRecipe[]){
        super(rows)
        this._userId = userId
    }
    get userId(){return this._userId}
    rowKey(row: IRecipe): string {
        return row._id
    }
    sort(list:IRecipe[]) {
        return list.sort((l,r) => l.name.localeCompare(r.name))
    }
}